import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CampaignStockVin } from '../../../../../core/interfaces/campaign-stock-vins';

@Component({
  selector: 'app-bastidores-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    NgSelectModule,
  ],
  templateUrl: './bastidores-form.component.html',
  styleUrl: './bastidores-form.component.css'
})
export class BastidoresFormComponent implements OnChanges {
  @Input() editingVin: CampaignStockVin | null = null;
  @Input() ladata: any = [];
  @Input() campaignStockId: string = '';
  @Output() saved = new EventEmitter<any>();
  @Output() cancelled = new EventEmitter<void>();

  bastidorForm: FormGroup;
  isEditMode = false;

  constructor(private fb: FormBuilder) {
    this.bastidorForm = this.fb.group({
      vin: ['', Validators.required],
      license_plate: [''],
      supplier_reference: [''],
      colour: [''],
      vehicle_discount_code: [''],
      dealership_id: [''],
      workshop_id: [''],
      manufacture_expected_date: [''],
      state: [''],
      external_state: [''],
      notes: [''],
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['editingVin']) {
      if (this.editingVin) {
        this.isEditMode = true;
        this.bastidorForm.patchValue({
          vin: this.editingVin.vin,
          license_plate: this.editingVin.license_plate || '',
          supplier_reference: this.editingVin.supplier_reference || '',
          colour: this.editingVin.colour || '',
          vehicle_discount_code: this.editingVin.vehicle_discount_code || '',
          dealership_id: this.editingVin.dealership_id || '',
          workshop_id: this.editingVin.workshop_id || '',
          manufacture_expected_date: this.editingVin.manufacture_expected_date || '',
          state: this.editingVin.state || '',
          external_state: this.editingVin.external_state || '',
          notes: this.editingVin.notes || '',
        });
        this.bastidorForm.get('vin')?.disable();
      } else {
        this.isEditMode = false;
        this.bastidorForm.reset();
        this.bastidorForm.get('vin')?.enable();
      }
    }
  }

  onSubmit(): void {
    if (this.bastidorForm.invalid) return;

    const formValues = this.bastidorForm.getRawValue();

    if (this.isEditMode) {
      this.saved.emit({
        reference: this.editingVin!.reference,
        body: {
          license_plate: formValues.license_plate || null,
          supplier_reference: formValues.supplier_reference || null,
          colour: formValues.colour || null,
          vehicle_discount_code: formValues.vehicle_discount_code || null,
          dealership_id: formValues.dealership_id || null,
          workshop_id: formValues.workshop_id || null,
          manufacture_expected_date: formValues.manufacture_expected_date || null,
          state: formValues.state || null,
          external_state: formValues.external_state || null,
          notes: formValues.notes || null,
        },
        isEdit: true,
      });
    } else {
      this.saved.emit({
        body: {
          campaign_stock_id: this.campaignStockId,
          vin: formValues.vin,
          license_plate: formValues.license_plate || null,
          supplier_reference: formValues.supplier_reference || null,
          colour: formValues.colour || null,
          vehicle_discount_code: formValues.vehicle_discount_code || null,
          dealership_id: formValues.dealership_id || null,
          workshop_id: formValues.workshop_id || null,
          manufacture_expected_date: formValues.manufacture_expected_date || null,
          state: formValues.state || null,
          external_state: formValues.external_state || null,
          notes: formValues.notes || null,
        },
        isEdit: false,
      });
    }
  }

  onCancel(): void {
    this.cancelled.emit();
  }
}
